import { useState } from "react";
import {Button, ModalTitle, Typography} from "@kaltura/ds-react-components";
import {translate} from "@mediaspace/shared/utils";
import {StyledModal, StyledModalContent, Separator, StyledIconRow, StyledTypography} from "./StyledComponents";
import {Edge24Icon, Chrome24Icon, Firefox24Icon} from "@kaltura/ds-react-icons";
import {useButtonAnalytics} from "@mediaspace/hooks";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";

const NotSupportedModal = () => {

    const [isOpen, setIsOpen] = useState<boolean>(true);

    const sendButtonAnalytics = useButtonAnalytics();

    const onClose = () => {
        sendButtonAnalytics("KME Alert - Room not supported - OK", ButtonClickAnalyticsType.CLOSE);
        setIsOpen(false)
    }

    return (
        <StyledModal open={isOpen}>
            <ModalTitle onClose={onClose} />
            <StyledModalContent>
                <Typography variant={"body1"}>
                    {translate("This session is not supported on this device.")}
                </Typography>
                <Separator />
                <Typography variant={"body1"}>
                    {translate("To join the session, open one of the following browsers:")}
                </Typography>
                <Separator />

                <StyledIconRow>
                    <StyledTypography aria-label={"Edge"}>
                        <Edge24Icon />
                    </StyledTypography>
                    <StyledTypography aria-label={"Chrome"}>
                        <Chrome24Icon />
                    </StyledTypography>
                    <StyledTypography aria-label={"Firefox"}>
                        <Firefox24Icon />
                    </StyledTypography>

                </StyledIconRow>

                <Button onClick={onClose} size={"large"}>
                    {translate("Got It!")}
                </Button>
            </StyledModalContent>
        </StyledModal>
    )
}

export default NotSupportedModal;
